import React, { createContext, PropsWithChildren } from 'react';

export type ProjectFilterConditionContextType = {
  isSearchActive: () => boolean;
  isMaturityDateEmpty: () => boolean;
  isYearProfitEmpty: () => boolean;
  isRoiEmpty: () => boolean;
};

type Props = {
  props: ProjectFilterConditionContextType;
};

export const ProjectFilterConditionContext = createContext<ProjectFilterConditionContextType>({
  isSearchActive: () => false,
  isMaturityDateEmpty: () => false,
  isYearProfitEmpty: () => false,
  isRoiEmpty: () => false,
});

function ProjectFilterConditionContextProvider(props: PropsWithChildren<Props>) {
  const { children, ...value } = props;
  return (
    <ProjectFilterConditionContext.Provider value={value.props}>
      {children}
    </ProjectFilterConditionContext.Provider>
  );
}

export default ProjectFilterConditionContextProvider;
